import { Component, signal } from '@angular/core';
import { BackgroundComponent } from '../../../shared/pages/background/background.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-authroized',
  standalone: true,
  imports: [
    RouterLink,
    BackgroundComponent],
  templateUrl: './not-authroized.component.html',
  styles: []
})
export class NotAuthroizedComponent {

isAuthorized = signal<boolean>(false);

showValues() {
  if (!this.isAuthorized()) {
    console.log("Usuario no autorizado.");
  }
}
setAuthorizationStatus(status: boolean) {
  this.isAuthorized.set(status);
}
}
